import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import "../../../components/customer-information/customer-information.css";
import { useDispatch } from "react-redux";
import AddButton from "../../buttons/button";
import successToast from "../../helper-components/success-toast";
import errorToast from "../../helper-components/error-toast";
import InputField from "../../forms/input-field";
import SelectField from "../../forms/select-field";
import {
  roundingMethodoptions,
  roundingRuleoptions,
} from "../../helper-components/data";
import { priceListAction } from "../../../redux/actions/general-action";
import { priceListEditAction, priceListEditByCSVAction } from "../../../redux/actions/discount-action";
import PriceListItemTable from "./price-list-items-table";
import SelectionCriteriaPopover from "./price-list-popover";
import { useHotkeys } from "react-hotkeys-hook";
import CheckBox from "../../forms/check-box-field";
import excelImg from "../../../assets/icons/excel.png"
import Papa from "papaparse";
import { DownloadIcon } from "lucide-react";
import { downloadAllTemplates } from "../../helper-components/helper-function";

const CreateEditViewPriceList = ({
  paginationProps,
  priceListData,
  setFilterData,
  filterData,
  setReload,
  reload,
  type
}) => {
  const [selectionCriteria, setSelectionCriteria] = useState(false);
  const dispatch = useDispatch();
  const [priceList, setPriceList] = useState([]);
  useEffect(() => {
    dispatch(priceListAction(onpriceSuccess, onpriceError));
  }, []);
  const onpriceSuccess = (data) => {
    setPriceList(
      data?.data?.map((item) => {
        return { label: item?.price_list_name, value: item?.price_list_id };
      })
    );
  };
  const onpriceError = (data) => {
    // errorToast(data?.message);
  };

  const initialValues = {
    price_list_id: priceListData?.pricelist?.price_list_id,
    price_list_name: priceListData?.pricelist?.price_list_name ?? "",
    default_base_price_list_id:
      priceListData?.pricelist?.default_base_price_list_id ?? "",
    default_factor: priceListData?.pricelist?.default_factor ?? "",
    margin_factor: priceListData?.pricelist?.margin_factor ?? "",
    rounding_method: priceListData?.pricelist?.rounding_method ?? "",
    rounding_rule: priceListData?.pricelist?.rounding_rule ?? "",
    default_price_list: Boolean(priceListData?.pricelist?.default_price_list),
    is_margin_percentage:
      priceListData?.pricelist?.is_margin_percentage ?? false,
  };

  const validationSchema = Yup.object().shape({
    price_list_name: Yup.string().required("Price list name is required"),
    default_base_price_list_id: Yup.string().required(
      "Default base price list ID is required"
    ),
    default_factor: Yup.number()
      .required("Discount % is required")
      .max(100, "Discount % cannot exceed 100"),
    margin_factor: Yup.number()
      .required("Margin % is required")
      .max(100, "Margin % cannot exceed 100"),
    rounding_method: Yup.string(),
    rounding_rule: Yup.string(),
  });

  const onSubmit = (values) => {
    const data = {
      default_base_price_list: priceList?.find(
        (item) => item?.value === values?.default_base_price_list_id
      )?.label,
      ...values,
    };
    dispatch(priceListEditAction(data, onSuccess, onError));
  };

  const onSuccess = (data) => {
    setReload(!reload);
    successToast(data?.message);
  };
  const onError = (data) => {
    errorToast(data?.data?.message);
  };

  useHotkeys("escape", () => {
    setSelectionCriteria(false);
  });

  function toggleSwitch() {
    const toggleButton = document.getElementById("necessary");
    const isChecked = toggleButton.getAttribute("data-state") === "checked";

    // Toggle the state
    if (isChecked) {
      toggleButton.setAttribute("data-state", "unchecked");
      toggleButton.setAttribute("aria-checked", "false");
    } else {
      toggleButton.setAttribute("data-state", "checked");
      toggleButton.setAttribute("aria-checked", "true");
    }
  }
  const handleFileUpload = (event,values) => {
  const is_margin_percentage=values?.is_margin_percentage;
  const price_list_id=values?.price_list_id;
  const file = event.target.files?.[0];
  if (!file) return;

  event.target.value = null;

  Papa.parse(file, {
    header: true,
    skipEmptyLines: true,
    complete: async (results) => {
      const parsedData = results.data;

      if (!parsedData || parsedData.length === 0 || !parsedData[0]) {
        errorToast("Error: The CSV file is empty or contains no valid records.");
        return;
      }
      const headers = (results.meta?.fields || []).map(h => String(h).trim());
      const seen = new Set();
      const duplicates = new Set();

      for (const h of headers) {
        const key = h.toLowerCase();
        if (seen.has(key)) duplicates.add(h);
        else seen.add(key);
      }

      if (duplicates.size > 0) {
        errorToast(`Duplicate header(s) found: ${[...duplicates].join(", ")}`);
        return;
      }
      const requiredBase = ["item_code", "batch_number"];
      const eitherOr = ["percentage", "selling_price"];

      const missingBase = requiredBase.filter((r) => !seen.has(r.toLowerCase()));
      if (missingBase.length > 0) {
        errorToast(`Missing required header(s): ${missingBase.join(", ")}`);
        return;
      }

      const hasEitherOr = eitherOr.some((r) => seen.has(r.toLowerCase()));
      if (!hasEitherOr) {
        errorToast(`Missing required header: either "percentage" or "selling_price" must be present.`);
        return;
      }

      const data={
        "data":parsedData,
        "is_margin":is_margin_percentage,
        "price_list_id":price_list_id,
      }
      console.log("************************");
      console.log(data);
      dispatch(priceListEditByCSVAction(data, onSuccess, onError));
    },
    error: (error) => {
      errorToast("Error parsing file:", error);
    },
  });
};
  // Attach the function to the button's click event
  document.getElementById("necessary")?.addEventListener("click", toggleSwitch);
  return (
    <>
      {selectionCriteria === true && (
        <SelectionCriteriaPopover
          setFilterData={setFilterData}
          filterData={filterData}
          setSelectionCriteria={setSelectionCriteria}
        />
      )}
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ handleSubmit, setFieldValue, values }) => {
          console.log("=== PRICE LIST FORM VALUES ===");
          console.log("default_price_list:", values?.default_price_list);
          console.log("isDisabled:", values?.default_price_list === true);
          return (
            <Form className="h-full pt-5">
              <div className="flex flex-col justify-between h-full ">
                <div>
                  <div className="flex flex-wrap">
                    <div className="w-[50%] 2xl:w-[25%] lg:w-[50%] px-5 xl:px-5 ">
                      <InputField
                        type="text"
                        name="price_list_name"
                        placeholder="Enter item name"
                        label="Name"
                        isRequired={true}
                        labelWidth="8rem"
                      />

                      <SelectField
                        // defaultValue="no_rounding"
                        placeholder={"Select rounding method"}
                        options={roundingMethodoptions}
                        label={"Rounding Method"}
                        id={"rounding_method"}
                        name="rounding_method"
                        isSearchable={true}
                        errMsgContainerClass="ps-2"
                        labelWidth="8rem"
                      />

                      {/* </div> */}
                    </div>
                    <div className="w-[50%] 2xl:w-[25%] lg:w-[50%] px-5 xl:px-5 ">
                      <SelectField
                        placeholder={"Select base price"}
                        options={priceList}
                        label={"Base Price List"}
                        id={"default_base_price_list_id"}
                        name="default_base_price_list_id"
                        isSearchable={true}
                        errMsgContainerClass="ps-2"
                        isRequired={true}
                        labelWidth="8rem"
                      />

                      <SelectField
                        placeholder={"Select rounding rule"}
                        options={roundingRuleoptions}
                        label={"Rounding rule"}
                        id={"rounding_rule"}
                        name="rounding_rule"
                        isSearchable={true}
                        errMsgContainerClass="ps-2"
                        labelWidth="8rem"
                      />
                    </div>
                    <div className="w-[50%] 2xl:w-[25%] lg:w-[50%] px-5 xl:px-5">
                      <InputField
                        isDisabled={
                          values?.is_margin_percentage ||
                          values?.price_list_id === "01HS5HJYWZ5DG2CW4EHX2W7A8V"
                        }
                        onKeyDown={(event) => {
                          if (event.key === "-" || event.key === "e") {
                            event.preventDefault();
                          }
                        }}
                        type="number"
                        name="default_factor"
                        placeholder="Enter Discount %"
                        label="Discount %"
                        isRequired={true}
                        labelWidth="8rem"
                      />
                      <InputField
                        isDisabled={
                          !values?.is_margin_percentage ||
                          values?.price_list_id === "01HS5HJYWZ5DG2CW4EHX2W7A8V"
                        }
                        onKeyDown={(event) => {
                          if (event.key === "-" || event.key === "e") {
                            event.preventDefault();
                          }
                        }}
                        type="number"
                        name="margin_factor"
                        placeholder="Enter margin %"
                        label="Margin %"
                        isRequired={true}
                        labelWidth="8rem"
                      />
                    </div>
                    <div className="w-[50%] 2xl:w-[25%] lg:w-[50%] px-5 xl:px-5">
                      <div
                        className={`flex gap-5 items-center mt-3 ${
                          values?.price_list_id === "01HS5HJYWZ5DG2CW4EHX2W7A8V"
                            ? "invisible"
                            : ""
                        }`}
                      >
                        <span
                          className={`${
                            values.is_margin_percentage
                              ? "text-disabled-color"
                              : ""
                          } text-nowrap`}
                        >
                          Discount %
                        </span>
                        <button
                          type="button"
                          role="switch"
                          aria-checked={values.is_margin_percentage}
                          onClick={() => {
                            setFieldValue(
                              "is_margin_percentage",
                              !values.is_margin_percentage
                            );
                          }}
                          data-state={
                            values.is_margin_percentage
                              ? "checked"
                              : "unchecked"
                          }
                          className={`peer inline-flex h-5 w-14 shrink-0 cursor-pointer items-center rounded-full border-2 border-white shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 ${
                            values.is_margin_percentage
                              ? "bg-D5E6Ff"
                              : "bg-D5E6Ff"
                          }`}
                          id="toggleSwitch"
                          aria-label="Toggle Switch"
                        >
                          <span
                            data-state={
                              values.is_margin_percentage
                                ? "checked"
                                : "unchecked"
                            }
                            className={`pointer-events-none block h-5 w-5 rounded-full bg-primary shadow-lg ring-0 transition-transform ${
                              values.is_margin_percentage
                                ? "translate-x-9"
                                : "translate-x-0"
                            }`}
                          ></span>
                        </button>
                        <span
                          className={`${
                            values.is_margin_percentage
                              ? ""
                              : "text-disabled-color"
                          } text-nowrap`}
                        >
                          Margin %
                        </span>
                {type === "edit" && (
                  <>
                    <input
                      type="file"
                      accept=".csv"
                      className="hidden"
                      id="csv-upload"
                      onChange={(e) => handleFileUpload(e, values)}
                    />

                    <label htmlFor="csv-upload">
                      <div
                        className="flex items-center justify-between px-[12px] h-[44px]
                          whitespace-nowrap rounded-[8px] gap-[10px]
                          bg-[var(--import-button-bg)] cursor-pointer
                          border border-[var(--import-button-border)]
                          hover:bg-[var(--import-button-bg)]
                          text-[var(--import-button-fg)]"
                      >
                        {/* Left side: Excel icon + text */}
                        <div className="flex items-center gap-[8px]">
                          <img width={20} height={20} src={excelImg} alt="excel-icon" />
                          <span>Import CSV</span>
                        </div>

                        <DownloadIcon
                          onClick={(e) => {
                            e.preventDefault();
                            downloadAllTemplates([
                              {
                                "documentType": "Price_List",
                                "expectedHeaders": [
                                  "item_code",
                                  "item_name",
                                  "batch_number",
                                  "percentage",
                                  "selling_price"
                                ]
                              }
                            ]
                            );
                          }}
                          className="w-5 h-5 text-[var(--import-button-fg)]"
                        />
                      </div>
                    </label>
                  </>
                )}
                      </div>
                      <div className="flex gap-12 items-center mt-12 ">
                        <CheckBox
                          conClass="flex flex-wrap justify-between gap-4 fw_600"
                          isDisabled={
                            initialValues?.default_price_list === true
                          }
                          onChange={(fieldName, checked) => {
                            if (checked) {
                              const confirmed = window.confirm(
                                "Do you want to make this as a default price list?"
                              );
                              if (confirmed) {
                                setFieldValue(fieldName, true);
                              } else {
                                // Keep the checkbox unchecked if user cancels
                                setFieldValue(fieldName, false);
                              }
                            } else {
                              setFieldValue(fieldName, false);
                            }
                          }}
                          items={[
                            {
                              label: "Set as default",
                              name: "default_price_list",
                              isRequired: false,
                            },
                          ]}
                        />
                        <AddButton
                          onclkFn={handleSubmit}
                          prefixIcon={false}
                          text="Save"
                          type="submit"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <PriceListItemTable
                  setReload={setReload}
                  reload={reload}
                  paginationProps={paginationProps}
                  priceListData={priceListData}
                />
                <div
                  style={{
                    bottom: "0",
                  }}
                  className="flex justify-end gap-5 px-10 mb-5x sticky bg-white py-4 invoice-bottom-container"
                >
                  <AddButton
                    onclkFn={() => setSelectionCriteria(!selectionCriteria)}
                    prefixIcon={false}
                    text="Selection Criteria"
                    type="button"
                  />
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default CreateEditViewPriceList;
